import React, { useState } from 'react';
import PlaceList from './PlaceList';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CheckBox from '../../common/CheckBox';
import DropDown from '../../common/DropDown';
import { RESEARCH_FILTER_BY, RESEARCH_SORT_BY } from '../../common/constants';
import MapIcon from '../../icons/mapFilled.svg';
import AssignUser from '../../icons/userAssign.svg';
import AssignUsersToPlacesModal from './AssignUsersToPlacesModal';
import ViewAllPlaces from './ViewAllPlaces';
import './styles.scss';
import { getPlaces, getSortBy, getFilterBy } from './redux/selectors';
import { setFilterBy, setSortBy } from './redux/actions';
function Places({ places, setFilter, setSort, sortBy, filterBy }) {
    const [addingUser, setAddUser] = useState(false);
    const [assignUser, setAssignUser] = useState(false);
    const [selectAllUsers, setSelectAllUsers] = useState(false);
    const [viewAll, setViewAll] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState({});
    const [tabId, setTabId] = useState('all');

    const hasSomeUnassignedPlaces = () => {
        return places.some((place) => place.isAssigned === false);
    };

    const hasSomeIndividuallySelectedPlaces = () => {
        return Object.keys(selectedUsers).some((u) => selectedUsers[u]);
    };

    const enableMultiAssignResearcher = () => {
        return (
            hasSomeIndividuallySelectedPlaces() ||
            (selectAllUsers && hasSomeUnassignedPlaces())
        );
    };

    const onSelectUser = (id) => {
        if (selectAllUsers) {
            const checkedPlaces = {};
            places.forEach((place) => {
                if (place.id != id && !place.isAssigned) {
                    checkedPlaces[place.id] = true;
                }
            });
            setSelectedUsers(checkedPlaces);
            setSelectAllUsers(false);
        } else {
            const allUsers = { ...selectedUsers };
            allUsers[id] = !allUsers[id];
            setSelectedUsers(allUsers);
        }
    };
    const filterByItem = RESEARCH_FILTER_BY.filter(
        (item) => item.id == (filterBy || 'name'),
    );
    const sortByItem = RESEARCH_SORT_BY.filter(
        (item) => item.id == (sortBy || 'ASC'),
    );

    return (
        <>
            <div className="places-list">
                <div className="tab-wrapper">
                    <div className="list-header justify-content-end margin-20-top">
                        <div>
                            {addingUser ? (
                                <>
                                    <button
                                        onClick={() => setAddUser(false)}
                                        className="btn btn-custom reset-btn btn-lg mt-3"
                                    >
                                        {' Cancel'}
                                    </button>
                                    <button
                                        disabled={
                                            !enableMultiAssignResearcher()
                                        }
                                        onClick={() => setAssignUser(true)}
                                        className="btn btn-custom btn-lg mt-3"
                                    >
                                        {' Next: Select Researcher'}
                                    </button>
                                </>
                            ) : (
                                <>
                                    {places.length ? (
                                        <>
                                            <button
                                                onClick={() => setViewAll(true)}
                                                className="btn btn-custom btn-lg mt-3"
                                            >
                                                <img src={MapIcon} />
                                                {' View All Places'}
                                            </button>
                                            <button
                                                onClick={() => setAddUser(true)}
                                                className="btn btn-custom btn-lg mt-3"
                                            >
                                                <img src={AssignUser} />
                                                {' Assign Researchers'}
                                            </button>
                                        </>
                                    ) : null}
                                </>
                            )}
                        </div>
                    </div>
                    <div className="list-header margin-24">
                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                            {addingUser ? (
                                <CheckBox
                                    id={'select-all-place-checkbox'}
                                    label="Select All"
                                    selected={selectAllUsers}
                                    isBold={true}
                                    onClick={() => {
                                        if (selectAllUsers) {
                                            setSelectedUsers({});
                                        }
                                        setSelectAllUsers(!selectAllUsers);
                                    }}
                                />
                            ) : places.length ? (
                                <>
                                    <li className="nav-item">
                                        <a
                                            className="nav-link active"
                                            id="tab-01"
                                            data-toggle="tab"
                                            href="#all"
                                            role="tab"
                                            aria-controls="all"
                                            aria-selected="true"
                                            onClick={() => setTabId('all')}
                                        >
                                            All
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className="nav-link"
                                            id="tab-02"
                                            data-toggle="tab"
                                            href="#assigned"
                                            role="tab"
                                            aria-controls="assigned"
                                            aria-selected="false"
                                            onClick={() => setTabId('assigned')}
                                        >
                                            Assigned
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className="nav-link"
                                            id="tab-03"
                                            data-toggle="tab"
                                            href="#unassigned"
                                            role="tab"
                                            aria-controls="unassigned"
                                            aria-selected="false"
                                            onClick={() =>
                                                setTabId('unassigned')
                                            }
                                        >
                                            Unassigned
                                        </a>
                                    </li>
                                </>
                            ) : null}
                        </ul>

                        <div className="d-flex">
                            {places.length ? (
                                <>
                                    <div className="dropdown first-dropdown">
                                        <DropDown
                                            label={'Sort On'}
                                            menuData={RESEARCH_FILTER_BY}
                                            onChange={setFilter}
                                            selectedOption={
                                                filterByItem[0].label
                                            }
                                            variant={'none'}
                                        />
                                    </div>
                                    <div className="dropdown">
                                        <DropDown
                                            label={'Sort By'}
                                            menuData={RESEARCH_SORT_BY}
                                            onChange={setSort}
                                            selectedOption={sortByItem[0].label}
                                            variant={'none'}
                                        />
                                    </div>
                                </>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                    <div className="tab-content" id="myTabContent">
                        <div
                            className="tab-pane fade show active"
                            id={tabId}
                            role="tabpanel"
                            aria-labelledby="tab-01"
                        >
                            <ul className="list-style">
                                <PlaceList
                                    selectable={addingUser}
                                    selectedUsers={selectedUsers}
                                    onSelectUser={onSelectUser}
                                    tabId={tabId}
                                    selectAll={selectAllUsers}
                                />
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <AssignUsersToPlacesModal
                places={places}
                allPlacesSelected={selectAllUsers}
                selectedPlaces={selectedUsers}
                isOpen={assignUser}
                handleClose={() => setAssignUser(false)}
            />
            {viewAll ? (
                <ViewAllPlaces open={viewAll} handleClose={setViewAll} />
            ) : null}
        </>
    );
}

Places.propTypes = {
    places: PropTypes.array,
    setFilter: PropTypes.func,
    setSort: PropTypes.func,
    sortBy: PropTypes.string,
    filterBy: PropTypes.string,
};

const mapStateToProps = (state) => {
    return {
        places: getPlaces(state),
        sortBy: getSortBy(state),
        filterBy: getFilterBy(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilter: (filterBy) => dispatch(setFilterBy(filterBy)),
        setSort: (sortBy) => dispatch(setSortBy(sortBy)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Places);
